"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentPinSchema = exports.PollStudentPinSchema = exports.MapStudentPinSchema = exports.LinkStudentPinSchema = exports.VideoStudentPinSchema = exports.DragQuestionStudentPinSchema = exports.WordCloudStudentPinSchema = exports.OpenQuestionStudentPinSchema = exports.OpenQuestionStudentPinSettingsSchema = exports.SlideStudentPinSchema = exports.QuizStudentPinSchema = void 0;
const zod_1 = require("zod");
const quiz_pin_1 = require("./quiz-pin");
const slide_pin_1 = require("./slide-pin");
const placeholder_pins_1 = require("./placeholder-pins");
const video_pin_1 = require("./video-pin");
const word_cloud_pin_1 = require("./word-cloud-pin");
const open_question_pin_1 = require("./open-question-pin");
const base_student_pin_1 = require("./base-student-pin");
exports.QuizStudentPinSchema = quiz_pin_1.QuizPinSchema.merge(zod_1.z.object({
    studentSettings: quiz_pin_1.QuizStudentPinSettingsSchema,
}));
exports.SlideStudentPinSchema = slide_pin_1.SlidePinSchema.merge(zod_1.z.object({
    studentSettings: slide_pin_1.SlideStudentPinSettingsSchema,
}));
exports.OpenQuestionStudentPinSettingsSchema = base_student_pin_1.AnswerSettingSchema.merge(zod_1.z.object({
    maximumNumberOfUploads: zod_1.z.nativeEnum(open_question_pin_1.NUMBER_OF_IMAGES_ALLOWED),
}));
exports.OpenQuestionStudentPinSchema = open_question_pin_1.OpenQuestionPinSchema.merge(zod_1.z.object({
    studentSettings: exports.OpenQuestionStudentPinSettingsSchema,
}));
// TODO: Add specific studentSettings for each placeholder
exports.WordCloudStudentPinSchema = word_cloud_pin_1.WordCloudPinSchema.merge(zod_1.z.object({
    studentSettings: zod_1.z.object({}),
}));
exports.DragQuestionStudentPinSchema = placeholder_pins_1.DragQuestionPinSchema.merge(zod_1.z.object({
    studentSettings: base_student_pin_1.AnswerSettingSchema,
}));
exports.VideoStudentPinSchema = video_pin_1.VideoPinSchema.merge(zod_1.z.object({
    studentSettings: zod_1.z.object({}),
}));
exports.LinkStudentPinSchema = placeholder_pins_1.LinkPinSchema.merge(zod_1.z.object({
    studentSettings: zod_1.z.object({}),
}));
exports.MapStudentPinSchema = placeholder_pins_1.MapPinSchema.merge(zod_1.z.object({
    studentSettings: zod_1.z.object({}),
}));
// TODO: @davey There's 3 variants of studentSettings Poll.Scale, Poll.Emoji, Poll.MultipleChoice
exports.PollStudentPinSchema = placeholder_pins_1.PollPinSchema.merge(zod_1.z.object({
    studentSettings: zod_1.z.object({}),
}));
exports.StudentPinSchema = zod_1.z.discriminatedUnion('type', [
    exports.QuizStudentPinSchema,
    exports.SlideStudentPinSchema,
    exports.OpenQuestionStudentPinSchema,
    exports.WordCloudStudentPinSchema,
    exports.DragQuestionStudentPinSchema,
    exports.VideoStudentPinSchema,
    exports.LinkStudentPinSchema,
    exports.MapStudentPinSchema,
    exports.PollStudentPinSchema,
]);
// If this gives you an error, update the StudentPinSchema union
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ensureTypesAreInSync = true;
//# sourceMappingURL=student.pin.js.map